// extracted by mini-css-extract-plugin
export default {"PromotionSelectWidget":"ObjectSelectWidget_PromotionSelectWidget__Uo30k"};